import { render } from "./BoardSize.vue?vue&type=template&id=661713ac"
import script from "./BoardSize.vue?vue&type=script&lang=js"
export * from "./BoardSize.vue?vue&type=script&lang=js"

import "./BoardSize.vue?vue&type=style&index=0&id=661713ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__